import React, { useState } from 'react';
import { WizardStepProps } from '../../WizardStepProps';
import { CreateSigningAppointmentFormData } from '../../04_confirmationStep/convertToCreateSigningAppointmentRequest';
import { useWizardStep } from '../../useWizardStep';
import { SignersStep } from '../../02_signersStep/SignersStep';
import { ConfirmationStep } from '../../04_confirmationStep/ConfirmationStep';
import { FormTemplate } from '../../shared/FormTemplate';
import { ProgressStep } from '../../shared/WizardProgress';
import { NotesForm } from './NotesForm/NotesForm';
import { NotesNavigation } from './NotesNavigation';

export const NotesStep: React.FC<WizardStepProps> = ({ wizardFormData, onClose, ...rest }) => {
  const [updatedWizardFormData, setUpdatedWizardFormData] = useState<CreateSigningAppointmentFormData>(wizardFormData);
  const { showNext, showPrevious, advance, goBack } = useWizardStep();
  const isDigSync = updatedWizardFormData.ownerType.includes('Email');

  if (showPrevious) {
    return <SignersStep wizardFormData={updatedWizardFormData} onClose={onClose} {...rest} />;
  }
  if (showNext) {
    return <ConfirmationStep wizardFormData={updatedWizardFormData} onClose={onClose} {...rest} />;
  }
  return (
    <FormTemplate progressStep={ProgressStep.METHOD} wizardFormData={wizardFormData}>
      <NotesForm
        advance={advance}
        updatedWizardFormData={updatedWizardFormData}
        setUpdatedWizardFormData={setUpdatedWizardFormData}
        onClose={onClose}
      >
        <NotesNavigation
          advance={advance}
          goBack={goBack}
          updatedWizardFormData={updatedWizardFormData}
          setUpdatedWizardFormData={setUpdatedWizardFormData}
          isDigSync={isDigSync}
        />
      </NotesForm>
    </FormTemplate>
  );
};
